import * as Yup from "yup";

export function initialValues(DZ) {
    return {
        asesor: DZ?.asesor || "",
        asesornom: DZ?.asesornom || "",
        base: DZ?.base || "",
        padecimiento: DZ?.padecimiento || "",
        area: DZ?.area?.split(', ') || [],
        activos: DZ?.activos || "",
        genero: DZ?.genero || "",
        nombre: DZ?.nombre || "",
        rangoedad: DZ?.rangoedad || "",
        tipopiel: DZ?.tipopiel || "",
        fragancia: DZ?.fragancia || false,
        presentacion: DZ?.presentacion || "",
        envase: DZ?.envase || "",
        objetivo: DZ?.objetivo || "",
        costologrado: DZ?.costologrado || "",
        excel: DZ?.excel || false,
        familia: DZ?.familia || "",
        caducidad: DZ?.caducidad || "",
    }
}

export function validationSchema() {
    return Yup.object({
        excel: Yup.boolean(true)
        .oneOf([true], "Debes activar el botón de Excel para continuar."),
        costologrado: Yup.string().required(true),
        base: Yup.string().required("El campo base es obligatorio."),
        padecimiento: Yup.string().required("El campo padecimiento es obligatorio."),
        area: Yup.array().min(1).required(true),
        activos: Yup.string().required("El campo activos es obligatorio."),
        rangoedad: Yup.string().required("El campo rango de edad es obligatorio."),
        tipopiel: Yup.string().required("El campo tipo de piel es obligatorio."),
        fragancia: Yup.boolean(),
        envase: Yup.string().required("El campo envase es obligatorio."),
        caducidad: Yup.number().required("El campo caducidad es obligatorio."),
    })
}
